module.exports = __webpack_public_path__ + "img/setTop.d013f22c.svg";